import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classes from './User.module.scss';
import Container from '@material-ui/core/Container';
import { Textfield } from '../../components/Textfield';
import { Buttons } from '../../components/Buttons';
import LoadingOverlay from 'react-loading-overlay';
import { config, message } from '../../constants';
import queryString from 'query-string';
import { ErrorMessage } from '../../components/Message/ErrorMessage';
import { SuccessMessage } from '../../components/Message/SuccessMessage';
import { DataPostApiV2, DataGetApiV2 } from '../../helpers/PostDataApi';
import Alert from '@mui/material/Alert';
import validator from '../../helpers/checkValidations';
import { checkPasswordStrength } from '../../helpers/commonFunction';
class SetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      misMatchError: [],
      token: '',
      claimId: '',
      userName: '',
      password: '',
      confirmPassword: '',
      errorMsg: null,
      successMessages: false,
      successDisplay: false,
      sideShow: true,
      isClaimAlreadyOpened: false,
      isLoading: true,
      isError: false,
      btnDisabled: true,
      passwordStrength: false,
      strengthStatus: undefined,
      passwordStrengthSeverity: undefined,
      error: {
        passwordError: false,
        userNameError: false,
        confirmPasswordError: false,
      },
    };
  }
  componentDidMount() {
    let params = queryString.parse(this.props.location.search);

    if ((params?.token, params?.claimId)) {
      const { token, claimId } = params;
      console.log(token);
      this.setState({ token, claimId });
      DataGetApiV2(config.BASEURL + 'v2/users/getPasswordSetClaimDetails', params, null, false)
        .then((response) => {
          if (response.data?.passwordClaim) {
            const passwordClaim = response.data.passwordClaim;
            this.setState({
              userName: passwordClaim.userName,
              expirationDate: passwordClaim.expirationDate,
              isClaimAlreadyOpened: !!passwordClaim.claimOpenedByUserDate,
              image: passwordClaim.image,
              isLoading: false,
            });
          }
        })
        .catch((error) => {
          // errors on finding data rather than it not existing.
          this.setState({
            errorMsg: error.response?.data?.message ?? message.ERROR_CONTACT_SUPPORT,
            isError: true,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        errorMsg: message.ERROR_CONTACT_SUPPORT,
        isError: true,
        isLoading: false,
      });
    }
  }

  handleChange(event, t) {
    let error = {};
    let { id, value } = event.target;
    let { password, confirmPassword } = this.state;
    this.setState({ [id]: value, error });
    let misMatchError = [];
    let successMessages = false;

    if (id === 'password') {
      const validateLength = validator(id, value);
      if (validateLength) {
        error[id + 'Error'] = true;
        this.setState({ error, passwordStrengthSeverity: 'error', strengthStatus: 'Limit exceeded 25 characters' });
        return;
      } else {
        error[id + 'Error'] = false;
        this.setState({ error, passwordStrengthSeverity: undefined });
      }
      const { passwordStrength, strengthStatus, passwordStrengthSeverity } = checkPasswordStrength(value);
      this.setState({
        passwordStrength: passwordStrength,
        strengthStatus: strengthStatus,
        passwordStrengthSeverity: passwordStrengthSeverity,
      });
    }
    if (!this.state.passwordStrength) {
      this.setState({ misMatchError, successMessages, btnDisabled: true });
    } else if (
      (id === 'confirmPassword' && password !== event.target.value) ||
      (id === 'password' && confirmPassword !== value)
    ) {
      misMatchError[0] = t('MisMatchPassword');
      this.setState({ misMatchError, successMessages, btnDisabled: true });
    } else {
      this.setState({ misMatchError, successMessages, btnDisabled: false });
    }
  }

  handleSubmit(_e, _t) {
    let misMatchError = [];
    let successMessages = false;
    let state = { ...this.state };
    let error = {};
    let errorFlag = false;
    Object.keys(state).forEach((key) => (state[key] === '' ? ((error[key + 'Error'] = true), (errorFlag = true)) : ''));

    if (errorFlag) {
      this.setState({ misMatchError, error, successMessages });
      return false;
    } else {
      const body = {
        claimId: this.state.claimId,
        token: this.state.token,
        password: this.state.password,
      };
      DataPostApiV2(config.BASEURL + `v2/users/setUserPassword`, body, null, false)
        .then((_response) => {
          this.setState({ successMessages: true, successDisplay: 'Password set successfully.' });
        })
        .catch((error) => {
          // errors on finding data rather than it not existing.
          this.setState({
            errorMsg: error.response?.data?.message ?? message.ERROR_CONTACT_SUPPORT,
            isError: true,
            isLoading: false,
          });
        });
    }
  }
  redirectLogin(_e) {
    window.location.href = '/login';
  }

  render() {
    const { t } = this.props;
    const { imageStyle } = styles;
    let { expirationDate } = this.state;
    expirationDate = new Date(expirationDate);
    let currentDateTime = new Date();
    const isLinkExpired = expirationDate.getTime() < currentDateTime.getTime();
    return (
      <div className={classes.userLink}>
        <LoadingOverlay active={this.state.isLoading} spinner text="please wait...">
          <div className={classes.paper}>
            {this.state.isError ? (
              <div className={classes.error}>
                {this.state.errorMsg} <a href={config.APPURL}>Back.</a>
              </div>
            ) : (
              <img
                src={
                  this.state.image
                    ? this.props.PAYTRACE_AWS_PATH + this.state.image
                    : `${this.props.PAYTRACE_AWS_PATH}logo-new.png`
                }
                style={imageStyle}
                height="100rem"
                alt="logo"
              />
            )}
            {isLinkExpired ? (
              <p className={classes.error}>
                This activation link has expired. Please contact Titanium Payments support staff to receive a new one.{' '}
                <a href={config.APPURL}>Back.</a>
              </p>
            ) : (
              <Container component="main" maxWidth="sm">
                {this.state.isError ? (
                  ''
                ) : (
                  <form className={classes.form} noValidate>
                    <Textfield
                      required={true}
                      error={this.state.error.userNameError}
                      id="userName"
                      type="userName"
                      labels={t('Username')}
                      value={this.state.userName}
                      width={true}
                      onChange={(e) => this.handleChange(e, t)}
                      focus={false}
                      disabled={true}
                    />
                    <div>
                      <Textfield
                        required={true}
                        error={this.state.error.passwordError}
                        id="password"
                        type="password"
                        labels={t('Password')}
                        value={this.state.password}
                        width={true}
                        onChange={(e) => this.handleChange(e, t)}
                        focus={false}
                      />
                      {this.state.passwordStrengthSeverity !== undefined && (
                        <div>
                          <Alert severity={this.state.passwordStrengthSeverity}>{this.state.strengthStatus}</Alert>
                        </div>
                      )}
                    </div>
                    <Textfield
                      required={true}
                      error={this.state.error.confirmPasswordError}
                      id="confirmPassword"
                      type="password"
                      labels={t('ConfirmPassword')}
                      value={this.state.confirmPassword}
                      width={true}
                      onChange={(e) => this.handleChange(e, t)}
                      focus={false}
                    />
                    {this.state.successMessages ? (
                      <Buttons
                        id="login"
                        type="button"
                        width={true}
                        variant="contained"
                        color="secondary"
                        className={classes.submit}
                        onClick={(e) => this.redirectLogin(e)}
                        text={t('ClickHereLogin')}
                        disabled={this.state.btnDisabled}
                      />
                    ) : (
                      <Buttons
                        id="save"
                        type="button"
                        width={true}
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={(e) => this.handleSubmit(e, t)}
                        text={t('Save')}
                        disabled={this.state.btnDisabled}
                      />
                    )}
                    <div className="passwordPolicy">
                      <h4>{message.PASSWORD_POLICY_MESSAGE}</h4>
                    </div>
                  </form>
                )}
              </Container>
            )}
            {this.state.misMatchError.length > 0 ? <ErrorMessage errors={[this.state.misMatchError]} /> : ''}
            {this.state.successMessages ? <SuccessMessage successes={[this.state.successDisplay]} /> : ''}
          </div>
        </LoadingOverlay>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    info: state.AdminUserReducer,
    PAYTRACE_AWS_PATH: state.EnvironmentVariablesReducer.data.PAYTRACE_AWS_PATH,
  };
}
SetPassword.propTypes = {
  t: PropTypes.func,
  location: PropTypes.object,
  PAYTRACE_AWS_PATH: PropTypes.string,
};

const styles = {
  imageStyle: { maxWidth: '95%' },
};
export default connect(mapStateToProps)(withTranslation()(SetPassword));
